import { Button, ButtonTheme, ButtonType } from "@ui/common/buttons/Button"
import { Grid, GridGap } from "@ui/common/grids/Grid"
import { Modal, ModalBody, ModalButtons, ModalContent, ModalHeader, ModalHeaderTitle } from "@ui/common/Modal"
import * as React from "react"

export function MeterSyncInfoModal({
    isVisible,
    onClose,
}: {
    isVisible: boolean
    onClose: () => void
}): JSX.Element {
    return (
        <Modal useContentTag={true} isVisible={isVisible} onClose={onClose}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>Automatic Meter Syncs</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <Grid columns={1} gap={GridGap.Small}>
                    Meter variances will automatically be adjusted when the work order is closed.
                    <br/>
                    <br/>
                    If there is a large variance ({'>'} 25 hours or 500 miles), the meter will not be adjusted automatically.  Large variances should be verified and manual synced, if necessary.
                    </Grid>
                </ModalBody>
                <ModalButtons>
                    <Button
                        label={"Close"}
                        type={ButtonType.Text}
                        onClick={onClose}
                    />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}